import "./CategoryCourses.css";
import React, { useEffect, useState } from "react";
import CardsCours from "../../../../Component/CardsCours/CardsCours";
import { FaDev } from "react-icons/fa";
import { VscProject } from "react-icons/vsc";
import { SiDigitalocean, SiAltiumdesigner } from "react-icons/si";
import { collection, onSnapshot, query } from "@firebase/firestore";
import { db, nmbrStudentByDomain } from "../../../../Firebase";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import Programmation from "./Component/Programmation";
import Design from "./Component/Design";
import GestionProjet from "./Component/GestionProjet";
import Marketing from "./Component/Marketing";

function CategoryCourses() {
  const [myCours, setMyCours] = useState([]);
  const [coursProg, setCoursProg] = useState(0);
  const [coursDesi, setCoursDesi] = useState(0);
  const [coursGest, setCoursGest] = useState(0);
  const [coursMark, setCoursMark] = useState(0);
  const reftabCours = query(collection(db, "cours"));

  const getUsers = () => {
    onSnapshot(reftabCours, (item) => {
      const currentUserId = sessionStorage.getItem("user_id");
      const data = [];
      item.forEach((i) => {
        data.push({ ...i.data(), id: i.id });
      });

      setMyCours(
        data?.filter(
          (elts) =>
            elts?.admin_id === currentUserId ||
            elts?.created_by === currentUserId
        )
      );
    });
  };

  useEffect(() => {
    getUsers();
    nmbrStudentByDomain(setCoursProg, "programmation");
    nmbrStudentByDomain(setCoursDesi, "Design");
    nmbrStudentByDomain(setCoursGest, "gestion de projet");
    nmbrStudentByDomain(setCoursMark, "marketing digital");
  }, []);

  const allCourses = myCours.filter((item) => item.isArchived === false);
  const coursProgr = allCourses.filter(
    (item) => item.domaine.toLowerCase() === "programmation"
  );
  const coursDesign = allCourses.filter(
    (item) => item.domaine.toLowerCase() === "design"
  );
  const coursGesProj = allCourses.filter(
    (item) => item.domaine.toLowerCase() === "gestion de projet"
  );
  const coursMarkting = allCourses.filter(
    (item) => item.domaine.toLowerCase() === "marketing digital"
  );

  const cardData = [
    {
      cours: "Informatique",
      texte: coursProgr === 1 ? "Etudiant" : "Etudiants",
      icon: <FaDev />,
      total: coursProg,
      nombre: coursProgr.length,
      couleur: "red",
    },
    {
      cours: "Design",
      texte: coursDesi === 1 ? "Etudiant" : "Etudiants",
      icon: <SiAltiumdesigner />,
      total: coursDesi,
      nombre: coursDesign.length,
      couleur: "blue",
    },
    {
      cours: "G-Projet",
      texte: coursGest === 1 ? "Etudiant" : "Etudiants",
      icon: <VscProject />,
      total: coursGest,
      nombre: coursGesProj.length,
      couleur: "green",
    },
    {
      cours: "Marketing",
      texte: coursMark === 1 ? "Etudiant" : "Etudiants",
      icon: <SiDigitalocean />,
      total: coursMark,
      nombre: coursMarkting.length,
      couleur: "#754ffe",
    },
  ];
  return (
    <div className="categorie-cours">
      <Row>
        {cardData.map(
          ({ cours, texte, icon, nombre, couleur, total }, index) => (
            <Col lg={3} md={6} key={index}>
              <CardsCours
                cours={cours}
                icon={icon}
                nombre={nombre}
                couleur={couleur}
                texte={texte}
                total={total}
              />
            </Col>
          )
        )}
      </Row>
      <Tabs
        transition={false}
        id="justify-tab-center"
        className="mt-4 fw-semibold fs-5 mestab center"
        defaultActiveKey="Programmation"
      >
        <Tab
          eventKey="Programmation"
          title="Programmation"
          className="text-dark tab1"
        >
          <Programmation />
        </Tab>
        <Tab eventKey="Design" title="Design" className="text-dark tab1">
          <Design />
        </Tab>
        <Tab
          eventKey="Gestion de projet"
          title="Gestion de projet"
          className="text-dark tab1"
        >
          <GestionProjet />
        </Tab>
        <Tab
          eventKey="Marketing Digitale"
          title="Marketing Digitale"
          className="text-dark tab1"
        >
          <Marketing />
        </Tab>
      </Tabs>
    </div>
  );
}

export default CategoryCourses;
